exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntd span {\n\tpadding: 10px 15px;\n\tdisplay: inline-block;\n}\n.action-column {\n\twidth: 46px;\n}\n.action-column a {\n\tdisplay: inline-block;\n}\n", ""]);
